import { render, staticRenderFns } from "./PhotoBookLayoutTemplate.vue?vue&type=template&id=49b875ee&scoped=true"
import script from "./PhotoBookLayoutTemplate.vue?vue&type=script&lang=js"
export * from "./PhotoBookLayoutTemplate.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookLayoutTemplate.vue?vue&type=style&index=0&id=49b875ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b875ee",
  null
  
)

export default component.exports